import { rem } from 'polished';
import styled from 'styled-components';

export const StyledEmployerCard = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;

  .employer__container {
    flex: 1;
    display: flex;
    position: relative;
    overflow: hidden;
    flex-direction: column;
    ${({ theme }) => theme.breakpoints.phablet`
      flex-direction: row;
    `}
  }
  .employer-layout__avatar {
    flex: 0;
    margin-bottom: ${rem(`8px`)};
    align-items: flex-start;
    ${({ theme }) => theme.breakpoints.phablet`
      margin-bottom: 0;
    `}
  }
  .employer-layout__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    ${({ theme }) => theme.breakpoints.phablet`
      padding-left: ${rem(`24px`)};
    `}
  }
  .content__top,
  .content__bot {
    display: flex;
  }
  .content__top {
    flex: 0 1;
  }
  .content__bot {
    padding-top: 8px;
    flex: 1 0;
    flex-direction: column;
    align-items: flex-start;
  }
  .content__bot-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .name {
    display: flex;
    flex: 1 0 100%;
    align-items: center;
  }
  .name__left {
    flex: 1;
    display: flex;
    justify-content: flex-start;
    .name__text {
      text-align: start;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      margin-bottom: 0;
    }
  }
  .name__right {
    flex: 0;
    padding-left: 12px;
  }

  .social {
    &:not(:first-child) {
      margin-top: 6px;
    }
    button {
      padding: 4px;
      width: 100%;
    }
    .body3 {
      font-size: 26px;
    }
  }
  .client--button {
    height: 24px;
    padding: 0;
    float: left;
    span.body3 {
      height: 24px;
      display: block;
    }
  }
`;
